import { CONSTANTS } from 'client/utils/constants';
import AssetDispositionAndLocation from './AssetDispositionAndLocation'
import { useSelector } from "react-redux";

const AssetDispositionAndLocationContainer = (props : any) => {
 const detailsByIdItem = props?.detailsByIdItem;
  const {
    transferOrderByIdData
  }: any = useSelector((state: any) => ({
    transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
  }))

  const isValidForPenaltyFee = (selectedOption?: any) => {
    if (selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_NO_TITLE || 
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_NO_TITLE ||
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_TITLED || 
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_TITLED) {
      return true
    } else {
      return false
    }
  }
    
  return (
    <AssetDispositionAndLocation
      transferOrderByIdData={transferOrderByIdData}
      detailsByIdItem = {detailsByIdItem}
      viewtype={props.viewtype}
      isValidForPenaltyFee = {isValidForPenaltyFee}
       />
  );
}

export default AssetDispositionAndLocationContainer